import { Store } from 'utils';

class IndexerRotate extends Store {

	getInitialState() {
		return {
            rotate: false,
            log: [],
            loadingIndex : false,
            loadingInvitation: false,
            successSendInvitation:false,
			numberNotSend: 0,
            stats:[],
            read:[],
            statsStatus:false
		}
	}

    onShowSuccess(state, data) {
        state.successSendInvitation = true;
        state.loadingInvitation = false;
        state.rotate = false;
        state.numberNotSend = data.users.length;
    }

    onHideMessageSendInvitation(state){
        state.successSendInvitation = false;
    }

    onChangeLoading(state,data){
        state.loadingIndex = true;
        state.rotate = false;
    }

    onChangeLoadingSendInvitation(state,data){
        state.loadingInvitation = true;
    }

    onRotateIndex(state,data){
	    state.rotate = data.results;
        state.loadingIndex = data.loading;
    }

    onLogChanged(state, data) {
       state.log = data.log;
       state.rotate = false;
    }

    onGetInvitationStats(state, data){
        state.stats = data.count;
        state.read = data.read;
        if(state.statsStatus == false)
        {
            state.statsStatus = true;
            state.rotate = false;
        }
        else
        {
            state.statsStatus = false;
            state.rotate = false;
        }

    }
    onGetStats(state, data){
        state.stats = data.count;
        state.read = data.read;
    }
}

const store = new IndexerRotate();
export default store;


// WEBPACK FOOTER //
// ./src/modules/model/IndexerRotate.js